// extracted by mini-css-extract-plugin
export default {"form":"Advertise_form__LS6DU","error":"Advertise_error__loS2+","actions":"Advertise_actions__iPD5j"};